import React from "react";
import {
  Svg,
  Line,
  Polyline,
  Polygon,
  Path,
  Rect,
  Circle,
  Ellipse,
  Text,
  Tspan,
  G,
  Stop,
  ClipPath,
  LinearGradient,
  RadialGradient,
} from "@react-pdf/renderer";

export const Ciseaux = ({color} : {color: string}) => {
  // @ts-ignore
  return (<Svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 74.4 122.78">
  <G fill={color}>
    <Path d="M72.77,98.29c-1.95-4.16-5.4-7.31-9.71-8.87h0c-2.83-1.02-5.81-1.29-8.72-.78l-2.69-14.75,12.73-21.48c12.85-21.49,9.13-43.86,8.96-44.8-.16-.93-.9-1.67-1.83-1.83-.94-.17-1.87.28-2.34,1.1l-22.53,39.57L38.5,1.85c-.17-.93-.91-1.66-1.84-1.81-.94-.16-1.87.29-2.33,1.12-.47.83-11.38,20.71-6.36,45.23l4.87,24.32-7.32,12.87c-2.59-1.45-5.44-2.15-8.49-2.15C7.54,81.51-.09,89.3,0,98.78c.1,9.42,7.79,17.01,17.18,17.01.06,0,.12,0,.17,0,5.21-.05,10.05-2.43,13.3-6.52h0s.04-.05.05-.07c.9-1.15,1.65-2.41,2.24-3.74l5.12-8.64,2.01,10.02c.11,1.43.39,2.84.85,4.2.03.1.06.2.1.29,1.73,4.87,5.49,8.66,10.34,10.41,1.91.69,3.89,1.03,5.86,1.03,2.49,0,4.96-.55,7.28-1.63,4.16-1.95,7.31-5.4,8.87-9.71,1.56-4.32,1.35-8.98-.6-13.14ZM61.69,107.21c-.9,2.48-3.63,3.76-6.11,2.86s-3.76-3.63-2.86-6.11,3.63-3.76,6.11-2.86c2.48.9,3.76,3.63,2.86,6.11ZM12.42,98.65c-.03-2.63,2.09-4.79,4.72-4.82s4.79,2.09,4.82,4.72c.03,2.63-2.09,4.79-4.72,4.82-2.63.03-4.79-2.09-4.82-4.72Z"/>
  </G>
</Svg>
);
};

export default Ciseaux;
